// default
export const RISK_ASSESSMENT = 'riskAssessment';
export const RISK_ASSESSMENT_SLICE_NAME = `${RISK_ASSESSMENT}Slice`;

// action
const GET_RISK_ASSESSMENT_SETTING = `${RISK_ASSESSMENT}/GET_RISK_ASSESSMENT_SETTING`;
const GET_RISK_ASSESSMENT_SETTING_APPROVAL_LINE = `${GET_RISK_ASSESSMENT_SETTING}/GET_RISK_ASSESSMENT_SETTING_APPROVAL_LINE`;
const ADD_RISK_ASSESSMENT_SETTING_APPROVAL_LINE = `${GET_RISK_ASSESSMENT_SETTING}/ADD_RISK_ASSESSMENT_SETTING_APPROVAL_LINE`;
const UPDATE_RISK_ASSESSMENT_SETTING_APPROVAL_LINE = `${GET_RISK_ASSESSMENT_SETTING}/UPDATE_RISK_ASSESSMENT_SETTING_APPROVAL_LINE`;
const DELETE_RISK_ASSESSMENT_SETTING_APPROVAL_LINE = `${GET_RISK_ASSESSMENT_SETTING}/DELETE_RISK_ASSESSMENT_SETTING_APPROVAL_LINE`;
const DELETE_USER_RISK_ASSESSMENT_SETTING_APPROVAL_LINE = `${GET_RISK_ASSESSMENT_SETTING}/DELETE_USER_RISK_ASSESSMENT_SETTING_APPROVAL_LINE`;
const GET_RISK_ASSESSMENT_SETTING_APPROVAL_LINE_DETAIL = `${GET_RISK_ASSESSMENT_SETTING}/GET_RISK_ASSESSMENT_SETTING_APPROVAL_LINE_DETAIL`;
const GET_RISK_ASSESSMENT_APPROVER_DETAIL = `${GET_RISK_ASSESSMENT_SETTING}/GET_RISK_ASSESSMENT_APPROVER_DETAIL`;
const ADD_USER_APPROVAL_LINE = `${GET_RISK_ASSESSMENT_SETTING}/ADD_USER_APPROVAL_LINE`;
const SUBMIT_RISK_ASSESSMENT = `${RISK_ASSESSMENT}/SUBMIT_RISK_ASSESSMENT`;
// actions
export const actions = {
  GET_RISK_ASSESSMENT_SETTING_APPROVAL_LINE,
  ADD_RISK_ASSESSMENT_SETTING_APPROVAL_LINE,
  UPDATE_RISK_ASSESSMENT_SETTING_APPROVAL_LINE,
  DELETE_RISK_ASSESSMENT_SETTING_APPROVAL_LINE,
  DELETE_USER_RISK_ASSESSMENT_SETTING_APPROVAL_LINE,
  GET_RISK_ASSESSMENT_SETTING_APPROVAL_LINE_DETAIL,
  GET_RISK_ASSESSMENT_APPROVER_DETAIL,
  ADD_USER_APPROVAL_LINE,
  SUBMIT_RISK_ASSESSMENT
};
